export default __webpack_public_path__ + "static/marknaufel-76191c6ed6a3f5a6dc7056358a51739c.png";